import React from 'react';
import { Paper, PaperTitle, PaperContent } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Content from 'containers/DeviceInformation/PractitionersContent';
import TachyReport from 'containers/TachyReport';
import s from './styles.module.scss';

const DeviceInformation = ({ t }) => (
  <Paper>
    <PaperTitle withBorder>{t('deviceInformation.deviceInformation')}</PaperTitle>
    <PaperContent>
      <Content className={s.noLeftAndRightMargin} />
      <TachyReport />
    </PaperContent>
  </Paper>
);

DeviceInformation.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(DeviceInformation);
